import routesReducers from './route';
import questCrudReducer from './questCrudReducer';
import questEventsReducer from './questEventsReducer';
import { findQuest, findEvent } from './questsHelpers';

export { findQuest, findEvent };

export const defaultState = {
  isFetching: false,
  isSending: false,
  isCopying: false,
  isSaving: false,
  isSaved: false,
  isNotSaved: false,
  questsReceived: false,
  syncingRoute: [],
  quests: [],
};

/**
 * Main quests reducer composing routes, CRUD, and event subreducers.
 * @param {Object} state - current state of quests slice
 * @param {Object} action - dispatched Redux action
 * @returns {Object}
 */
export default function quests(state = defaultState, action) {
  const routesReducersState = routesReducers(state, action);
  if (routesReducersState) {
    return routesReducersState;
  }

  const crudState = questCrudReducer(state, action);
  if (crudState) {
    return crudState;
  }

  const eventsState = questEventsReducer(state, action);
  if (eventsState) {
    return eventsState;
  }

  return state;
}
